// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-82dc3968] .v-lazy-image[alt*=Dining],[data-v-82dc3968] .v-lazy-image[alt*=Mattress]{-o-object-fit:contain;object-fit:contain}[data-v-82dc3968] .star-rating{--stroke-color:var(--cp-primary_support)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
